// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.link-pending-withdrawal-modal-modal_card-nUOGp {
  width: 344px;
  height: auto;
  max-height: 640px;  
}

.link-pending-withdrawal-modal-modal_content-Uop_0 {
  padding: 0px 20px;
}

.link-pending-withdrawal-modal-selectTitle-PXvLC, .link-pending-withdrawal-modal-transactionTitle-hlUuA {
  display: block;
  font-size: 15px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.75);
}

.link-pending-withdrawal-modal-selectTitle-PXvLC {
  margin: 20px 0px;
}

.link-pending-withdrawal-modal-transactionTitle-hlUuA {
  margin: 24px 0px 10px;
}

.link-pending-withdrawal-modal-detailItem_container-t_1uS {
  width: auto;
  flex-wrap: wrap;
  row-gap: 12px;
  column-gap: 16px;
  padding: 18px 0px;
  margin: 0px 1px;
}

.link-pending-withdrawal-modal-detailItem_title-s16eA {
  font-size: 15px;
  font-weight: normal;
}

.link-pending-withdrawal-modal-detailItem_text-EYXhi {
  font-weight: 500;
  font-size: 15px;
  color: rgba(0, 0, 0, 0.75);
}

.link-pending-withdrawal-modal-detailItem_green-ka9B2 {
  color: var(--money-color);
}
`, "",{"version":3,"sources":["webpack://./src/pages/bank-account/pending-transactions/link-pending-withdrawal-modal/link-pending-withdrawal-modal.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".modal_card {\n  width: 344px;\n  height: auto;\n  max-height: 640px;  \n}\n\n.modal_content {\n  padding: 0px 20px;\n}\n\n.selectTitle, .transactionTitle {\n  display: block;\n  font-size: 15px;\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.75);\n}\n\n.selectTitle {\n  margin: 20px 0px;\n}\n\n.transactionTitle {\n  margin: 24px 0px 10px;\n}\n\n.detailItem_container {\n  width: auto;\n  flex-wrap: wrap;\n  row-gap: 12px;\n  column-gap: 16px;\n  padding: 18px 0px;\n  margin: 0px 1px;\n}\n\n.detailItem_title {\n  font-size: 15px;\n  font-weight: normal;\n}\n\n.detailItem_text {\n  font-weight: 500;\n  font-size: 15px;\n  color: rgba(0, 0, 0, 0.75);\n}\n\n.detailItem_green {\n  color: var(--money-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal_card": `link-pending-withdrawal-modal-modal_card-nUOGp`,
	"modal_content": `link-pending-withdrawal-modal-modal_content-Uop_0`,
	"selectTitle": `link-pending-withdrawal-modal-selectTitle-PXvLC`,
	"transactionTitle": `link-pending-withdrawal-modal-transactionTitle-hlUuA`,
	"detailItem_container": `link-pending-withdrawal-modal-detailItem_container-t_1uS`,
	"detailItem_title": `link-pending-withdrawal-modal-detailItem_title-s16eA`,
	"detailItem_text": `link-pending-withdrawal-modal-detailItem_text-EYXhi`,
	"detailItem_green": `link-pending-withdrawal-modal-detailItem_green-ka9B2`
};
export default ___CSS_LOADER_EXPORT___;
